import styled from '@emotion/styled'
import { themeColor, stylesIf } from 'utils/styles'
import { SelectMenu, CollapsibleWidget, Paragraph } from 'components/patterns'
import ChipList from 'components/ChipList'
import Chip from 'components/ChipList/Chip'

const HEADER_FOOTER_OFFSET = 280

export const AdvancedSearchWrap = styled.div`
  max-height: calc(100vh - ${HEADER_FOOTER_OFFSET}px);
  height: calc(100vh - ${HEADER_FOOTER_OFFSET}px);
`

export const StyledSelectMenu = styled(SelectMenu)((props) => {
  const { isHorizontalLayout } = props
  return `
    margin-bottom: 8px;
    .ant-select {
      width: ${isHorizontalLayout ? `300px` : `285px`};
    }
  `
})

export const StyledChipList = styled(ChipList)((props) => {
  const { isHorizontalLayout } = props
  const addFeatureStyle = `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 230px;
    border: 0px;
    &:hover {
      border: 0px;
    }
    ${Chip} {
      width: 200px !important;
    }
    `
  return `
     ${stylesIf(isHorizontalLayout, addFeatureStyle)}
    `
})

export const ChipHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 200px;
`

export const ActiveFilters = styled.span`
  font-size: 12px;
  padding-right: 5px;
  color: rgba(7, 7, 15, 0.4);
`

export const ClearFilters = styled.span`
  font-size: 12px;
  color: rgba(7, 7, 15, 0.7);
  padding-right: 5px;
  cursor: pointer;
`

export const AdvancedSearchArea = styled.div`
  margin-top: 16px;
`

export const AdvancedSearchFiltersHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const ChipFilterBox = styled.div((props) => {
  const { isHorizontalLayout } = props
  const sideBarStyle = `
    background: ${themeColor('greySecondary')};
    border-radius: 4px;
    padding: 5px 0;
    margin-bottom: 10px;
  `
  const addFeatureStyle = `
    border-radius: 4px;
    padding: 5px;
    align-items: flex-start;
    max-width: 410px;
  `
  return `
   ${isHorizontalLayout ? addFeatureStyle : sideBarStyle}
  `
})

export const StyledWidgetHeader = styled.span`
  height: 12px;
  color: ${themeColor('bluePrimary')};
`

export const StyledCollapsibleWidget = styled(CollapsibleWidget)`
  margin-top: 20px;
  /* Bug 499040 Issue 13: antd 3 sets background-color: #fff on
     .ant-collapse-borderless (the root element). ghost prop is not
     supported in antd v3, so we explicitly clear it here. */
  &&.ant-collapse-borderless {
    background-color: transparent;
  }
  &&.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    margin-top: -20px;
    padding-left: 0px !important;
  }
  &&.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    left: 45px;
  }
  &&.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
    margin-top: -6px;
  }
  &&.ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 0px;
  }
`

export const StyledParagraph = styled(Paragraph)`
  margin-bottom: 15px;
`

export const AdvancedFilterBox = styled.div((props) => {
  const { isHorizontalLayout } = props
  const sideBarStyle = `
    background: ${themeColor('greySecondary')};
    border-radius: 4px;
    padding: 5px;
    margin-bottom: 10px;
  `
  const addFeatureStyle = `
    margin-top: 2px;
    margin-bottom: 10px;
  `
  return `
    ${isHorizontalLayout ? addFeatureStyle : sideBarStyle}
  `
})
